
// -------------------------------------------//
//              Kermi Smart Slider
// -------------------------------------------//


angular.module('app.directives.smartslider',[]).
directive('kermiSmartSlider',
	[
		'$document', 'appConfig','$q',
		function($document, appConfig, $q) {
			var obj = {
				x : 0,
				startX : 0,
				initValue : 0,
				scope:
				{
					model:"=model",
					savebtn: '@',
					//Options
					options:"=kOptions",
					// Slider Withd
					sliderwidth:'=sliderWidth',
					// Show Buttons (Savebuttons)
					withButtons: '=withButtons',
					// CallBack when saved
					kCallback: '=kCallback',
					// CallBack when saved
					kCallbackParams: '=kCallbackParams',
					// Hide Info
					hideInfo : '=hideInfo',
					maxWidth : '=maxWidth',
					// Suppress Apply on Write model
					supressApply : '=supressApply'
				},
				restrict:'AE',
				templateUrl: 'views/form/smartslider.html',



				// -------------------------------------------//
				//              Calculate Functions
				// -------------------------------------------//
				getPercentFromValue : function(value,min,max,steps)
				{
					var delta = parseFloat(max) - parseFloat(min);
					var deltaval = parseFloat(value) - parseFloat(min);
					//alert('max' + max + 'min' +min + 'delta:'+delta + 'deltaval:'+deltaval + 'ergebnis %' + ((deltaval/delta) * 100));
					var back = (parseFloat(deltaval)/parseFloat(delta)) * 100;

					return back;
				},


				// -------------------------------------------//
				//              Link Function
				// -------------------------------------------//
				link: function(scope,element, attrs, controller)
				{


					// -------------------------------------------//
					//              Init
					// -------------------------------------------//
				    //var startX = offset(element);
					//let startY = 0;
				    let x = 0;
				    //let y = 0;





					/* Prepare incoming Data */


					//var datapoint = scope.datapoint;
					//var DatapointConfigId = 0;
					var min = 0;
					//var max = 1;
					//var value = 1;
					//var unit = '';
					//var DeviceId = 0;
					var container = element.find('div').eq(0);
					var handle = element.find('div').eq(2);
					var progress = element.find('div').eq(1);
					var label = element.find('span').eq(0);
					var info = element.find('span').eq(1);
					//var buttons = element.find('div').eq(3);
					var byHandle = false;
					//var saveclear = false;
					var initValue = undefined;
                    var newleft = 0;
					//var objtype = 0;
					//var flags = 0;
					var steps = 1.0;
					var touchConfig = appConfig();
					var touchStart = touchConfig.touchStart;
					var touchMove = touchConfig.touchMove;
					var touchEnd =touchConfig.touchEnd;

					scope.interact = false;
					container.css({
						position: 'relative',
						'width' : scope.sliderwidth + 'px',
						'min-width' : scope.sliderwidth + 'px'
					});

					scope.$watch('options', function(value){
						//console.log('watch options',value);
						if(!scope.interact && value != undefined)
						{
							if(Object.keys(scope.options).length == 2){
								scope.sliderwidth = 30;
							}
							container.css({
								position: 'relative',
								'width' : scope.sliderwidth + 'px',
								'min-width' : scope.sliderwidth + 'px'
							});
							var maxWidth;

							if(!scope.maxWidth){
								maxWidth = 200;
							}else{
								maxWidth = scope.maxWidth;
							}

							label.css({
								'max-width': (maxWidth -scope.sliderwidth)+'px'
							});
							if(scope.infoStyle == 'show'){ scope.infoStyleInt = 'show';  };
							// datapoint = value;
							renderSliderByValue(scope.model);
							//scope.toggleButton(false);
						}
					});
					scope.$watch('model', function(value){
						if(!scope.interact )
						{
							// datapoint = value;
							scope.model = value;
							scope.value = scope.model;

							renderSliderByValue(scope.value);

							//scope.toggleButton(false);
						}

					});


					// -------------------------------------------//
					//              Set all Vars
					// -------------------------------------------//
					function setVars(value,config)
					{
						scope.min = min = 0;
						if(scope.options){
							scope.max = Object.keys(scope.options).length;
							scope.optionsCount = Object.keys(scope.options).length -1;
							scope.firstKey = Object.keys(scope.options)[0];
						}
						steps = 1;
						if(value != undefined)
						{
							scope.value = value;
						}else{
							scope.value = min;
							initValue = min;
						}

						newleft = obj.getPercentFromValue(scope.value , min, scope.optionsCount );
						renderSliderByValue( scope.value );
					}

					// -------------------------------------------//
					//             Init Function
					// -------------------------------------------//
					function initSlider(value,config){
						setVars(value,config);

						if(newleft < 0){newleft = 0;};
						if(newleft > 100){newleft = 100;};

						handle.css({
							'left': newleft + '%'
						});

						progress.css({
							width:  newleft + '%'
						});
						/*info.css({
							width:  (parseInt(scope.sliderwidth) + 20 ) + 'px',
							'margin-left':-((parseInt(scope.sliderwidth) + 20 )/2)+'px'
						});*/



					};



					var smartContainerDown =  function(event)
					{
						event.originalEvent.preventDefault();
						event.originalEvent.stopPropagation();
						scope.interact = true;
						byHandle = false;

						renderSliderByMouseLeft(touchConfig.touch(event).touches[0].clientX);
						info.addClass('show');
						scope.$digest();
						$document.on(touchMove, function(e){ touchConfig.touch(e,mousemove) });
						$document.on(touchEnd, function(e){ touchConfig.touch(e,mouseup) });
					}

					container.on(touchStart, function(e){ touchConfig.touch(e,smartContainerDown) });



					// -------------------------------------------//
					//              Handle down
					// -------------------------------------------//



					 var smartHandleDown = function(event) {
						scope.interact = true;
						event.originalEvent.preventDefault();
						event.originalEvent.stopPropagation();
						// Prevent default dragging of selected content
						element.removeClass('manual');
						info.addClass('show');

						byHandle = true;
						//initValue = scope.value;
						// Add Eventlistener move + up;



						$document.on(touchMove, function(e){ touchConfig.touch(e,mousemove) });
						$document.on(touchEnd, function(e){ touchConfig.touch(e,mouseup) });
						renderSliderByMouseLeft(touchConfig.touch(event).touches[0].clientX);


					};
					handle.on(touchStart, function(e){ touchConfig.touch(e,smartHandleDown) });
/*

					function onMouseMove(e) {
						e.touches = [{clientX: e.clientX, clientY: e.clientY}];
						mousemove(e);
					}
					// -------------------------------------------//
					//               Routing                      //
					// -------------------------------------------//
					/* Functions */
					function mousemove(event) {
						renderSliderByMouseLeft(event.touches[0].clientX);
						scope.$digest();
					}




					// -------------------------------------------//
					//              Get Element Offset
					// -------------------------------------------//

					function offset(elm) {
						try {return elm.offset();} catch(e) {}
						var rawDom = elm[0];
						var _x = 0;
						var _y = 0;
						var body = document.documentElement || document.body;
						var scrollX = window.pageXOffset || body.scrollLeft;
						var scrollY = window.pageYOffset || body.scrollTop;
						_x = rawDom.getBoundingClientRect().left + scrollX;
						_y = rawDom.getBoundingClientRect().top + scrollY;
						return { left: _x, top:_y };
					}


					// -------------------------------------------//
					//              Render Slider by Mouse Left
					// -------------------------------------------//
					function renderSliderByMouseLeft(mouseLeft)
					{
						// IE Fires last event with NAN
						if(mouseLeft)
						{
							var percent = ( ( mouseLeft - offset(container).left) / scope.sliderwidth ) * 100;

							if(percent < 0)
							{
								percent = 0;
							}else if(percent > 100)
							{
								percent = 100;
							};
							//console.log(scope.sliderwidth);

							var count = Object.keys(scope.options).length - 1;
							var onestep = 100/ count;
							var value = Math.round( percent / onestep ) ;
							scope.value = Object.keys( scope.options )[ value ];
							percent = (value * onestep);
							scope.model = Object.keys( scope.options )[ value ];

							renderSlider(percent);

						}
					}

					// -------------------------------------------//
					//              Reder Slider by Value
					// -------------------------------------------//
					var renderSliderByValue = function(value)
					{
						if(value == undefined){ return };
						//console.log('value is da');

						if(scope.options == undefined || value == undefined){ return };
						var o = Object.keys(scope.options);


						//console.log(value);
						var found = false;
						//console.log(scope.options);
						var i = 0;
						for(var key in scope.options)
						{
							if(scope.options.hasOwnProperty(key))
							{
								//console.log(key +'-'+scope.options[key]+'--'+value);
								//console.log(typeof value);
								//console.log(typeof key);
								var a,b;
								//console.log( key.toString() +'-+++-'+ value.toString());
								if( key.toString() == value.toString() )
								{
									found = {'i':i,'value':value};
									break;
								}
								i++;
							}
						}
						/*for(var i = 0; i < o.length; i++)
						{
							console.log(o[i]+'-'+ value);

						}*/

						if(found != false)
						{
							//console.log('found it on '+value+'-'+found.i);

							x = ( 100 / ( o.length - 1)  ) * found.i;
						}

						if(x < 0)
						{
							x = 0;
						}else if(x > 100)
						{
							x = 100;
						};

					    renderSlider(x);
					}
					// -------------------------------------------//
					//              Render -> Set CSS
					// -------------------------------------------//
					function renderSlider(x)
					{

						progress.css({
							width:  x + '%'
						});
						handle.css({
							left:  x + '%'
						});
					}


					function mouseup(event) {
						event.originalEvent.preventDefault();
						event.originalEvent.stopPropagation();
						event.originalEvent.stopImmediatePropagation();

						scope.dragging = false;
						info.removeClass('show');
						element.addClass('manual');
						$document.off(touchMove);
						$document.off(touchEnd);
						handle.off(touchEnd);
						/*var t = touchConfig.touch(event).touches;
						if(t && t.length > 0){
							renderSliderByMouseLeft( t[0].clientX);
						}*/


							scope.writeToModel();

						scope.$digest(function () {

						});
					}

					scope.writeToModel = function (){

						if(typeof scope.kCallback == 'function')
						{
							var defer = $q.defer();
							scope.kCallback({promise:defer,params : scope.kCallbackParams,value:scope.value, withButtons : scope.withButtons});
							// Write to Model if return value == true;
							defer.promise.then(function(aktVal){
								// scope.model = scope.value;
								scope.interact = false;
								// We need to render by new model, because scope.model $watch does not fire in fact of scope.interact is true
								// This is important if we change by Slider and datapoint directive shows buttons for save and clear
								// While Buttons were shown no new data (e.g. interval) were parsed.
								scope.model = aktVal;
								scope.value = scope.model;
								renderSliderByValue(scope.model);

							},function(){

							});
						}else{
							// Nothing to check;
							scope.model = scope.value;
							scope.interact = false;
							// Careful using this.
							// Without a callback (Scenes SetDatapoint) we can run into performance issues
							// But we need this because Parent Object needs dirtyCheck cycle to display current value
							// Todo: In future use pherhaps implement a scope.supressApply to handle this
							if(scope.supressApply){ return };
							scope.$apply();
						}

					}

					// -------------------------------------------//
					//              Reset Value
					// -------------------------------------------//
					scope.resetValue = function()
					{
						scope.value = initValue;
						renderSliderByValue(initValue);
					}


					initSlider(scope.model);
				}

			};
			return obj ;


		}]);
